import { useEffect, useState } from "react";
import ReactEcharts from "echarts-for-react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { EventChartDataAPI } from "../services/api";

function EventChart({ selectedEvent, nFormatter }) {
  const [isLoading, setIsLoading] = useState(false);
  const [chartData, setChartData] = useState({});

  const getChartData = async () => {
    setIsLoading(true);
    try {
      let res = await EventChartDataAPI({ id: selectedEvent.id });
      if (res.status) {
        setChartData(res.data);
      }
    } catch (err) {
      console.log("err getChartData - Event Chart", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getChartData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedEvent]);

  let xAxisLabel =
    Object.keys(chartData).length && Object.keys(chartData.actual);
  let actualData =
    Object.values(chartData).length && Object.values(chartData.actual);
  let forecastData =
    Object.values(chartData).length && Object.values(chartData.forecast);

  const chartOption = {
    xAxis: {
      type: "category",
      axisLine: { onZero: false },
      // name: "Time (Hours)",
      // nameLocation: 'center'
      data: xAxisLabel,
    },
    yAxis: {
      type: "value",
      // axisLine: { onZero: false },
      // name: "Profit / Loss",
      axisLabel: {
        formatter: function (value) {
          return `${nFormatter(value, selectedEvent.unit)}${
            selectedEvent.unit ? selectedEvent.unit : ""
          }`;
        },
      },
    },
    tooltip: {
      show: true,
      trigger: "axis",
      axisPointer: {
        type: "cross",
      },
      formatter: function (params) {
        let plText = `<div style="text-align:left;">${params[0].axisValueLabel}<br>`;
        params.map((item) => {
          let marker = `<span style="${
            item.borderColor !== undefined
              ? `border:1px solid ${item.borderColor};`
              : ""
          }display:inline-block;margin-right:4px;border-radius:5px;width:10px;height:10px;background-color:${
            item.color
          };"></span>`;
          plText += `${marker} ${item.seriesName}: <strong>${nFormatter(
            item.data,
            selectedEvent.unit
          )}${selectedEvent.unit ? selectedEvent.unit : ""}</strong><br></div>`;
        });
        return plText;
      },
    },
    dataZoom: [
      {
        type: "slider",
        xAxisIndex: 0,
        filterMode: "empty",
      },
      {
        type: "slider",
        yAxisIndex: 0,
        filterMode: "empty",
      },
      {
        type: "inside",
        xAxisIndex: 0,
        filterMode: "empty",
      },
      {
        type: "inside",
        yAxisIndex: 0,
        filterMode: "empty",
      },
    ],
    legend: {
      // orient: 'vertical',
      display: true,
    },
    series: [
      {
        name: "Actual",
        type: "bar",
        // data: this.formatData(buyHoldtime, buyVol),
        data: actualData,
        itemStyle: {
          color: "#1890ff",
        },
        barGap: "-100%", // this changed
        // barCategoryGap: '80%', // this changed
      },
      {
        name: "Forecast",
        type: "bar",
        data: forecastData,
        itemStyle: {
          borderColor: "#F6A940",
          color: "#F6A94000",
          borderWidth: 2,
        },
      },
    ],
  };

  return (
    <div className="row px-2">
      <div className="col-12 bg-light py-3 fs-6">
        <div className="bold_text">Actual vs Forecast</div>
      </div>
      <div className="col-12 py-3 text-center">
        <div className="d-flex flex-row align-items-center">
          <img
            src={selectedEvent.flag}
            alt={selectedEvent.regionCode}
            className="flagImg mr-1"
          />
          <span className="mx-2">{selectedEvent.regionCode}</span>
          {selectedEvent.eventTitle}
        </div>
        {isLoading ? (
          <Spin
            indicator={
              <LoadingOutlined style={{ fontSize: 50 }} spin className="mt-5" />
            }
          />
        ) : (
          <ReactEcharts option={chartOption} />
        )}
      </div>
    </div>
  );
}

export default EventChart;
